import { infoCardDefaultProps } from '../../shared/boxes/infoCard/infoCardProps';
import { accordionPanelDefaultProps } from '../../shared/boxes/accordionPanel/accordionPanelProps';
import { THEMED_BLOCKS } from '../puck/themedBlocks';
import { carouselSlideDefaults, logoStripCarouselProps } from '../blocks/web/CarouselBlock/carouselDefaults';
import roomBefore from './samples/room-before.svg';
import roomAfter from './samples/room-after.svg';

// Sans la config Puck : les galeries de l'inspecteur, que cette config
// déclare, s'en servent aussi (elles reçoivent les composants en paramètre).

export const SAMPLE_TEXT = "Texte d'aperçu : il ne se trouve pas sur votre site, il sert seulement à visualiser "
  + "l'effet des réglages. Modifiez un paramètre et la page se met à jour ici, en direct.";

export const block = (type, props) => ({ type, props: { id: `preview-${type}`, ...props } });

// Contenu d'exemple des éléments qu'un document porte ; les composants propres
// au site montrent celui de leurs valeurs par défaut (libellé, slides, étapes…).
const SAMPLE_PROPS = {
  scrollStory: () => ({ steps: [{ title: 'Préparation', description: SAMPLE_TEXT, media: roomBefore }, { title: 'Installation', description: SAMPLE_TEXT, media: roomAfter }, { title: 'Contrôle', description: SAMPLE_TEXT, media: roomAfter }] }),
  hotspotImage: () => ({ src: roomAfter, alt: 'Aménagement de démonstration', points: [{ id: 'demo-window', x: 28, y: 40, title: 'Lumière naturelle', description: 'Une explication à découvrir.' }, { id: 'demo-space', x: 55, y: 70, title: 'Espace de travail', description: 'Un aménagement adapté.' }] }),
  imageComparison: () => ({ beforeSrc: roomBefore, afterSrc: roomAfter, beforeLabel: 'Avant', afterLabel: 'Après' }),
  video: () => ({
    previewChapters: true,
    chapters: [
      { title: 'Fonctionnement', time: 0 },
      { title: 'Maintenance', time: 45 },
      { title: 'Sécurité', time: 90 },
    ],
  }),
  table: () => ({
    columns: ['Prestation', 'Quantité', 'Prix'].map((label, i) => ({
      key: `col_${i}`, label, widthPercent: 100 / 3, cellType: 'text',
    })),
    rows: [['Audit', '1', '1 200 €'], ['Accompagnement', '3', '2 400 €'], ['Suivi', '12', '600 €']]
      .map((cells) => ({ cells: cells.map((value) => ({ value })) })),
    mergedCells: [],
    columnsDisposition: [],
  }),
  accordion: () => ({
    ...accordionPanelDefaultProps(),
    question: 'Comment se déroule la mise en place ?',
    answer: `<p>${SAMPLE_TEXT}</p>`,
    // La réponse et son fond font partie du style : on les montre.
    previewOpened: true,
  }),
  infoCard: () => ({ ...infoCardDefaultProps(), value: '98 %', description: 'Clients satisfaits' }),
};

export const samplePropsOf = (kind, components) => (SAMPLE_PROPS[kind]
  ? SAMPLE_PROPS[kind]()
  : components[THEMED_BLOCKS[kind].type].defaultProps);

/**
 * Le bloc d'un composant du thème, garni de son contenu d'exemple, avec les
 * valeurs de style `values` (au format du bloc : celles d'un style du thème
 * ou d'un style de la galerie). `components` : ceux de la config Puck.
 */
export function styledElementBlock(kind, values, components) {
  const themed = THEMED_BLOCKS[kind];
  const sample = samplePropsOf(kind, components);
  // Un carrousel sans texte de slide est un bandeau de médias : des slides de
  // démo sans média n'y montreraient que des cases grises. Avec texte, une
  // troisième slide : une galerie de trois colonnes doit en montrer trois.
  const carouselSlides = kind === 'carousel' ? {
    slides: values?.showSlideText === false
      ? logoStripCarouselProps().slides
      : [...sample.slides, carouselSlideDefaults({
        title: 'Un dernier argument',
        description: 'Une phrase pour conclure.',
        slideBackground: '#fff4e6',
      })],
  } : {};
  return block(themed.type, themed.write({ ...sample, ...carouselSlides }, values));
}

